import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsOptimizeFieldSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-optimize-field-scheme-view',
	path: '/jira/settings/issues/field-schemes/:schemeId/optimize',
};
